// Helper function to preserve original time when updating dates
export const preserveOriginalTime = (date: any, originalDate: any) => {
  if (!date) return null;

  if (originalDate) {
    // Extract time from original date's ISO string
    const timeMatch = originalDate.match(/T(\d{2}:\d{2}:\d{2}\.\d{3})/);
    const exactTime = timeMatch ? timeMatch[1] : '00:00:00.000';

    const [hours, minutes, secondsAndMillis] = exactTime.split(':');
    const newDate = date
      .hour(parseInt(hours))
      .minute(parseInt(minutes))
      .second(parseInt(secondsAndMillis.split('.')[0]))
      .millisecond(parseInt(secondsAndMillis.split('.')[1]));

    return newDate;
  }

  // If no original date (new entry), use current time
  return date
    .hour(date.hour())
    .minute(date.minute())
    .second(date.second())
    .millisecond(date.millisecond());
};

export const handleMergeDateTime = (selectedDate: any) => {
  // Return null if no date provided
  if (!selectedDate) {
    return null;
  }

  // If it's a dayjs object, convert to native Date
  const dateObj = selectedDate?.toDate ? selectedDate.toDate() : selectedDate;

  // Return null if dateObj is still null/undefined
  if (!dateObj || !(dateObj instanceof Date)) {
    return null;
  }

  // Get the original date's time components (for preserving seconds and milliseconds)
  const originalISOString = dateObj?.toISOString();
  const originalTimeMatch = originalISOString?.match(/T\d{2}:\d{2}:(\d{2})\.(\d{3})/);
  const [_, originalSeconds, originalMilliseconds] = originalTimeMatch || ['', '00', '000'];

  // Get the selected hours and minutes from the date object
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  // Create new date with selected hours/minutes and original seconds/milliseconds
  const newDate = new Date();
  newDate.setUTCFullYear(dateObj.getUTCFullYear());
  newDate.setUTCMonth(dateObj.getUTCMonth());
  newDate.setUTCDate(dateObj.getUTCDate());
  newDate.setUTCHours(hours);
  newDate.setUTCMinutes(minutes);
  newDate.setUTCSeconds(parseInt(originalSeconds));
  newDate.setUTCMilliseconds(parseInt(originalMilliseconds));

  return newDate;
};

export const handleAddMergeDateTime = (selectedDate: any) => {
  if (!selectedDate) {
    return null;
  }

  // Ensure selectedDate is converted to a valid JavaScript Date
  let selectedDateJS: Date;

  if (selectedDate instanceof Date) {
    selectedDateJS = selectedDate;
  } else if (selectedDate.toDate) {
    selectedDateJS = selectedDate.toDate(); // Convert from dayjs/moment
  } else if (typeof selectedDate === "string" || typeof selectedDate === "number") {
    selectedDateJS = new Date(selectedDate); // Convert from string/ISO format
  } else {
    return null;
  }

  if (isNaN(selectedDateJS.getTime())) {
    return null;
  }

  const currentDate = new Date(); // Get current date and time

  // Extract date components from selected date
  const year = selectedDateJS.getFullYear();
  const month = selectedDateJS.getMonth();
  const day = selectedDateJS.getDate();

  // Extract time components from current date
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  const milliseconds = currentDate.getMilliseconds();

  // Create a new Date object with selected date and current time
  const mergedDate = new Date(year, month, day, hours, minutes, seconds, milliseconds);
  return mergedDate;
};